/**
 * html2canvas Background Image Fix
 * Background-image CSS property'si html2canvas tarafından her zaman doğru render edilmez
 * Bu yardımcı fonksiyon background-image'i geçici bir img elementi olarak ekler
 */

(function(window) {
    'use strict';

    /**
     * Prepare element for html2canvas by converting background-image to img element
     * @param {HTMLElement} element - Element with background-image
     * @returns {Object} - { cleanup: function } - Call cleanup after rendering
     */
    function prepareBackgroundForCanvas(element) {
        const computedStyle = window.getComputedStyle(element);
        const bgImage = computedStyle.backgroundImage;
        
        let tempImg = null;
        
        // Check if element has background-image
        if (bgImage && bgImage !== 'none') {
            // Extract URL from background-image
            const urlMatch = bgImage.match(/url\(['"]?([^'"]+)['"]?\)/);
            
            if (urlMatch && urlMatch[1]) {
                const imageUrl = urlMatch[1];
                
                // Create temporary img element
                tempImg = document.createElement('img');
                tempImg.src = imageUrl;
                tempImg.style.position = 'absolute';
                tempImg.style.top = '0';
                tempImg.style.left = '0';
                tempImg.style.width = '100%';
                tempImg.style.height = '100%';
                tempImg.style.objectFit = 'contain';
                tempImg.style.objectPosition = 'center';
                tempImg.style.pointerEvents = 'none';
                tempImg.style.zIndex = '-1';
                tempImg.classList.add('html2canvas-bg-fix');
                tempImg.crossOrigin = 'anonymous'; // For CORS
                
                // Insert as first child
                element.insertBefore(tempImg, element.firstChild);
                
                console.log('✅ Background image converted to <img> for html2canvas:', imageUrl);
            }
        }
        
        // Return cleanup function
        return {
            cleanup: function() {
                if (tempImg && tempImg.parentNode) {
                    tempImg.parentNode.removeChild(tempImg);
                    console.log('🧹 Temporary background image removed');
                }
            }
        };
    }

    /**
     * Enhanced html2canvas wrapper with background-image fix
     * @param {HTMLElement} element - Element to capture
     * @param {Object} options - html2canvas options
     * @returns {Promise<HTMLCanvasElement>}
     */
    async function captureWithBackgroundFix(element, options = {}) {
        // Prepare background
        const bgFix = prepareBackgroundForCanvas(element);
        
        try {
            // Wait a bit for image to load
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Capture with html2canvas
            const canvas = await html2canvas(element, {
                backgroundColor: null,
                scale: 2,
                useCORS: true,
                allowTaint: true,
                foreignObjectRendering: false,
                imageTimeout: 0,
                logging: false,
                ...options
            });
            
            // Cleanup
            bgFix.cleanup();
            
            return canvas;
        } catch (error) {
            // Cleanup even on error
            bgFix.cleanup();
            throw error;
        }
    }

    // Export to global scope
    window.Html2CanvasFix = {
        prepareBackgroundForCanvas: prepareBackgroundForCanvas,
        captureWithBackgroundFix: captureWithBackgroundFix
    };

    console.log('✅ html2canvas Background Fix module loaded');

})(window);
